import * as types from './types'

const initialState = {
  adminToolbox: null,
  managerToolbox: null,
  employeeToolbox: null,
  latestToolbox: null,
  adminLayouts: null,
  managerLayouts: null,
  employeeLayouts: null,
  refetchToolboxes: true,
}

const addWidgetReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_LATEST_TOOLBOX:
      return { ...state, latestToolbox: action.payload }
    case types.SET_ADMIN_TOOLBOX:
      return { ...state, adminToolbox: action.payload }
    case types.SET_MANAGER_TOOLBOX:
      return { ...state, managerToolbox: action.payload }
    case types.SET_EMPLOYEE_TOOLBOX:
      return { ...state, employeeToolbox: action.payload }
    case types.REFETCH_TOOLBOXES:
      return { ...state, refetchToolboxes: action.payload }

    case types.SET_ADMIN_LAYOUTS:
      return { ...state, adminLayouts: action.payload }
    case types.SET_MANAGER_LAYOUTS:
      return { ...state, managerLayouts: action.payload }
    case types.SET_EMPLOYEE_LAYOUTS:
      return { ...state, employeeLayouts: action.payload }
    default:
      return state
  }
}

export default addWidgetReducer
